const tours = {
  tour: "यात्रा", // translated 
  tours: "टूर्स", // translated 
  addOn: "ऐड ऑन", // translated 
  addOns: "ऐड ऑन", // translated 
  availableEscapes: "उपलब्ध पलायन", // translated 
  availableExperiences: "उपलब्ध अनुभव", // translated 
  getRequest: "अनुरोध प्राप्त करें", // translated 
  sendRequest: "अनुरोध भेजा", // translated 
};


export default tours;
